export default [
  {
    path: "/course",
    name: "course",
    component: () => import("@/views/course/index.vue"),
    meta: {
      title: "课程预告"
    }
  },
  {
    path: "/course-detail",
    name: "course-detail",
    component: () => import("@/views/course/detail.vue"),
    meta: {
      title: "课程详情"
    }
  }
];
